export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID || '',
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID || '',
      identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID || '',
      allowGuestAccess: true
    }
  }
};

export const apiConfig = {
  baseUrl: import.meta.env.VITE_API_GATEWAY_URL || '',
  region: import.meta.env.VITE_AWS_REGION || 'eu-west-2',
  endpoints: {
    // queueId is optional — if provided returns single-queue path; else batch path
    getMetrics: (queueId?: string): string => queueId ? `/metrics/${queueId}` : '/metrics',
    createShareLink: '/share-links',
    getShareLink: (linkId: string) => `/share-links/${linkId}`
  }
};